import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import { connect } from "react-redux";
import Select from "react-select";
import Creatable from "react-select/lib/Creatable";
import DatePicker from "react-datepicker";
import moment from "moment";
import { buildOptions, postDischargeDestinationOptions } from "../utils";
import withFetchHook from "../withFetchHook";
import { sendStaffAppMetaData } from "../staffApp/eventTriggers";

class PastOccupancyFormModal extends Component {
  state = {
    beds: [],
    bedsLoading: false
  }

  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value)
  }

  componentDidUpdate(prevProps) {
    if (this.props.occupancy.group_id !== prevProps.occupancy.group_id ||
      this.props.occupancy.moved_in_at !== prevProps.occupancy.moved_in_at ||
      this.props.occupancy.moved_out_at !== prevProps.occupancy.moved_out_at) {
      this.getBeds();
    }
  }

  getBeds() {
    const { id, organizationName } = this.props;
    const { group_id, moved_in_at, moved_out_at } = this.props.occupancy;

    this.setState({ bedsLoading: true });
    this.props.fetch(`/organizations/${organizationName}/beds.json`, {
      data: {
        by_group: group_id,
        by_vacant: {
          resident_id: id
        }
      }
    }).then((beds) => {
      this.setState({ beds, bedsLoading: false })
    })
  }

  buildBedLabel(bed) {
    let label = `${bed.full_label} ${bed.price !== null ? ` - $${bed.price}` : ''}`;

    if (bed.current_occupancy != null) {
      if (bed.current_occupancy.estimated_discharge_date == null) {
        label = label + ` (Occupied)`;
      } else {
        label = label + ` (Occupied, est discharge at: ${moment(bed.current_occupancy.estimated_discharge_date).format("MMM Do YY")})`;
      }
    }

    return label;
  }

  updateOccupancies(occupancy) {
    const { organizationName, id } = this.props;

    return this.props.fetch(`/organizations/${organizationName}/residents/${id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: {
          occupancies_attributes: [occupancy]
        }
      })
    })
  }

  deleteOccupancy() {
    const { occupancy, deleteOccupancy, closeModal, isStaffApp } = this.props;

    this.setState({ loading: true });

    this.updateOccupancies({
      id: occupancy.id,
      _destroy: true
    }).then(() => {
      this.setState({ loading: false });
      deleteOccupancy(occupancy);
      if (isStaffApp) {
        alert('Occupancy successfully deleted.')
        this.setDefaultStaffAppMetaData()
      }
      closeModal();
    });
  }

  saveOccupancy() {
    const { occupancy, updateOccupancies, closeModal, isStaffApp } = this.props;

    this.setState({ loading: true });

    this.updateOccupancies(occupancy).then((data) => {
      this.setState({ loading: false });
      updateOccupancies(data.occupancies);
      if (isStaffApp) {
        alert('Occupancy changes saved.')
        this.setDefaultStaffAppMetaData()
      }

      closeModal();
    });
  }

  handleDischargeButton = () => {
    this.handleClose()
    if (this.props.isStaffApp) sendStaffAppMetaData({
      lbbUri: 'dispatch://closeDischargeForm',
      hLabel: 'Discharge',
      lbbLabel: 'Occupancies',
    })
    this.props.dischargeOccupancy(this.props.occupancy)
  }

  setDefaultStaffAppMetaData = () => sendStaffAppMetaData(this.props.tabDefaultMetaData)

  saveOccupancyFunction = (e) => {
    this.props.dispatch(this.saveOccupancy())
  }

  componentDidMount() {
    document.addEventListener('saveOccupancy', this.saveOccupancyFunction)
  }

  componentWillUnmount() {
    document.removeEventListener('saveOccupancy', this.saveOccupancyFunction)
  }

  render() {
    const {
      group_id,
      estimated_length_of_stay,
      estimated_discharge_date,
      moved_in_at,
      moved_out_at,
      reason_for_discharge,
      is_successful_discharge,
      post_discharge_destination,
      bed_id
    } = this.props.occupancy;
    const { users, reason_for_discharge_options, isStaffApp, occupancy, hasDelete, hasEdit } = this.props
    const groupOptions = this.props.groups.map((group) => ({ value: group.id, label: group.name }));
    const selectedGroup = this.props.groups.find((group) => group.id === group_id)
    const group = groupOptions.find((option) => option.value === group_id);
    const reasonForDischargeOptions = buildOptions(reason_for_discharge_options);
    const reasonForDischarge = reasonForDischargeOptions.find((option) => option.value === reason_for_discharge);
    const postDischargeDestination = postDischargeDestinationOptions.find((option) => option.value === post_discharge_destination);
    const bedOptions = this.state.beds.map((bed) => ({ value: bed.id, label: this.buildBedLabel(bed) }));
    const bed = bedOptions.find((option) => option.value === bed_id) || null;

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        {
          !isStaffApp &&
          <Modal.Header closeButton>
            <Modal.Title>Occupancy</Modal.Title>
          </Modal.Header>
        }
        <Modal.Body className={hasEdit ? "" : "form-modal-width"}>
          {hasEdit ? (
            <>
              <Form.Group controlId="occupancyGroupId">
                <Form.Label>Facility</Form.Label>
                <Select
                  value={group}
                  options={groupOptions}
                  onChange={(option) => {
                    this.handleChange('group_id', option.value);
                    this.handleChange('add_to_group_chat', undefined);
                  }} />
              </Form.Group>
              <Form.Group controlId="occupancyEstimatedLengthOfStay">
                <Form.Label>Estimated Length of Stay</Form.Label>
                <Form.Control
                  value={estimated_length_of_stay}
                  onChange={(e) => {
                    this.handleChange('estimated_length_of_stay', e.target.value);
                  }} />
              </Form.Group>
              <Form.Group controlId="occupancyEstimatedDischargeDate">
                <Form.Label>Estimated Discharge Date</Form.Label>
                <DatePicker
                  selected={estimated_discharge_date ? moment(estimated_discharge_date) : null}
                  className="form-control"
                  onChange={(date) => {
                    this.handleChange(
                      'estimated_discharge_date',
                      date ? date.format("YYYY-MM-DD") : null
                    )
                  }} />
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group controlId="occupancyMovedInAt">
                    <Form.Label>Admit Date</Form.Label>
                    <DatePicker
                      selected={moved_in_at ? moment(moved_in_at) : null}
                      className="form-control"
                      onChange={(date) => {
                        this.handleChange(
                          'moved_in_at',
                          date ? date.format("YYYY-MM-DD") : null
                        )
                      }} />
                  </Form.Group>
                </Col>
                {
                  moved_out_at &&
                  <Col sm={6}>
                    <Form.Group controlId="occupancyMovedOutAt">
                      <Form.Label>Discharged</Form.Label>
                      <DatePicker
                        selected={moved_out_at ? moment(moved_out_at) : null}
                        className="form-control"
                        onChange={(date) => {
                          this.handleChange(
                            'moved_out_at',
                            date ? date.format("YYYY-MM-DD") : null
                          )
                        }} />
                    </Form.Group>
                  </Col>
                }
              </Row>
              {
                !!moved_out_at &&
                <Form.Group controlId="occupancyPostDischargeDestination">
                  <Form.Label>Post Discharge Destination</Form.Label>
                  <Select
                    value={postDischargeDestination}
                    options={postDischargeDestinationOptions}
                    onChange={(option) => {
                      this.handleChange('post_discharge_destination', option == null ? null : option.value);
                    }} />
                </Form.Group>
              }
              {
                !!moved_out_at &&
                <Form.Group controlId="occupancyReasonForDischarge">
                  <Form.Label>Reason for Discharge</Form.Label>
                  <Creatable
                    isClearable
                    value={reasonForDischarge}
                    options={reasonForDischargeOptions}
                    onChange={(option) => {
                      this.handleChange('reason_for_discharge', option == null ? null : option.value);
                    }} />
                </Form.Group>
              }
              {
                !!moved_out_at &&
                <Form.Group controlId="occupancyIsSuccessfulDischarge">
                  <Form.Label>Is Successful Discharge</Form.Label>
                  <Select
                    value={is_successful_discharge ? { label: 'Yes', value: true } : { label: 'No', value: false }}
                    options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}
                    onChange={(option) => { this.handleChange('is_successful_discharge', option.value) }} />
                </Form.Group>
              }
              {
                bedOptions.length > 0 &&
                <Form.Group controlId="occupancyBedId">
                  <Form.Label>Room & Bed / Price #</Form.Label>
                  <Select
                    value={bed}
                    options={bedOptions}
                    isLoading={this.state.bedsLoading}
                    isClearable={true}
                    onChange={(option) => {
                      this.handleChange(
                        'bed_id',
                        option ? option.value : ''
                      );
                    }} />
                </Form.Group>
              }
              {
                !!selectedGroup && selectedGroup.managed_group_chats.length > 0 && users.length > 0 && this.props.action === 'new' &&
                <Form.Group controlId="occupancyGroupId">
                  <Form.Label>Add To Group Message?</Form.Label>
                  <Select
                    value={occupancy.add_to_group_chat ? { label: 'Yes', value: true } : { label: 'No', value: false }}
                    options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}
                    onChange={(option) => { this.handleChange('add_to_group_chat', option.value) }} />
                </Form.Group>
              }
            </>
          ) : (
            <>
              <Form.Group>
                <Form.Label>Facility</Form.Label>
                <div className="form-control-plaintext">{selectedGroup?.name || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Estimated Length of Stay</Form.Label>
                <div className="form-control-plaintext">{estimated_length_of_stay || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Estimated Discharge Date</Form.Label>
                <div className="form-control-plaintext">{estimated_discharge_date ? moment(estimated_discharge_date).format('MM/DD/YYYY') : 'N/A'}</div>
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Admit Date</Form.Label>
                    <div className="form-control-plaintext">{moved_in_at ? moment(moved_in_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
                {moved_out_at && (
                  <Col sm={6}>
                    <Form.Group>
                      <Form.Label>Discharged</Form.Label>
                      <div className="form-control-plaintext">{moved_out_at ? moment(moved_out_at).format('MM/DD/YYYY') : 'N/A'}</div>
                    </Form.Group>
                  </Col>
                )}
              </Row>
              {moved_out_at && (
                <Form.Group>
                  <Form.Label>Post Discharge Destination</Form.Label>
                  <div className="form-control-plaintext">{post_discharge_destination || 'N/A'}</div>
                </Form.Group>
              )}
              {moved_out_at && (
                <Form.Group>
                  <Form.Label>Reason for Discharge</Form.Label>
                  <div className="form-control-plaintext">{reason_for_discharge || 'N/A'}</div>
                </Form.Group>
              )}
              {moved_out_at && (
                <Form.Group>
                  <Form.Label>Is Successful Discharge</Form.Label>
                  <div className="form-control-plaintext">{is_successful_discharge ? 'Yes' : 'No'}</div>
                </Form.Group>
              )}
              {bedOptions.length > 0 && (
                <Form.Group>
                  <Form.Label>Room & Bed / Price #</Form.Label>
                  <div className="form-control-plaintext">{bed?.label || 'N/A'}</div>
                </Form.Group>
              )}
            </>
          )}
        </Modal.Body>
        {
          !isStaffApp ?
            <Modal.Footer>
              {
                this.props.action === "edit" && hasDelete &&
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    const { occupancy } = this.props;
                    this.deleteOccupancy(occupancy);
                  }}>
                  Delete
                </Button>
              }
              <Button
                variant="info"
                onClick={() => {
                  this.saveOccupancy();
                }}>
                {this.props.action === "edit" ? "Update" : "Create"}
              </Button>
            </Modal.Footer> :
            <>
              {
                this.props.action === 'edit' &&
                <>
                  <div className="p-3">
                    {
                      occupancy["current?"] && !occupancy["moved_out_at"] &&
                      <Button
                        className="w-100"
                        variant="outline-info"
                        onClick={this.handleDischargeButton}>
                        Discharge
                      </Button>
                    }
                  </div>
                  <div className="p-3">
                    {
                      hasDelete &&
                      <Button
                        onClick={() => this.deleteOccupancy(this.props.occupancy)}
                        className="w-100"
                        variant="outline-danger">
                        Delete
                      </Button>
                    }
                  </div>
                </>
              }
            </>
        }
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.pastOccupancyModal.show,
    occupancy: state.ui.pastOccupancyModal.occupancy,
    action: state.ui.pastOccupancyModal.action,
    groups: state.groups,
    organizationName: state.organization.name,
    id: state.resident.id,
    reason_for_discharge_options: state.org_dependant_data.reason_for_discharge_options,
    resident: state.resident,
    isStaffApp: state.config.isStaffApp,
    resident_tabs: state.config.resident_tabs,
    users: state.users,
    config: state.config,
    tabDefaultMetaData: state.config.tab_default_meta_data.find(tab => tab.detail == 'past_occupancies'),
    hasDelete: state.current_user.permissions.includes("Delete"),
    hasEdit: state.current_user.permissions.includes("Edit"),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: "CLOSE_OCCUPANCY_FORM_MODAL" }),
    updateOccupancies: (occupancies) => dispatch({ type: "UPDATE_OCCUPANCIES", payload: { occupancies } }),
    createOccupancy: (occupancy) => dispatch({ type: "CREATE_OCCUPANCY", payload: { occupancy } }),
    deleteOccupancy: (occupancy) => dispatch({ type: "DELETE_OCCUPANCY", payload: { occupancy } }),
    updateField: (name, value) => dispatch({ type: "UPDATE_OCCUPANCY_FIELD", payload: { name, value } }),
    dischargeOccupancy: (occupancy) => dispatch({ type: "OPEN_DISCHARGE_OCCUPANCY_MODAL", payload: occupancy }),
    dispatch: (func) => dispatch(func()),
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(PastOccupancyFormModal));
